import { render, staticRenderFns } from "./BankTransfer.vue?vue&type=template&id=5f3d368a&scoped=true"
import script from "./BankTransfer.vue?vue&type=script&lang=js"
export * from "./BankTransfer.vue?vue&type=script&lang=js"
import style0 from "./BankTransfer.vue?vue&type=style&index=0&id=5f3d368a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d368a",
  null
  
)

export default component.exports